import useCapabilities, {
  DOMAIN,
  PERMISSION,
  useCanViewPersonMembershipBool,
  useRequireCapability
} from "@/hooks/useCapabilities";

export function usePersonMembershipAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonMembership = useCanViewPersonMembershipBool();

  useRequireCapability({ domain: DOMAIN.PEOPLE, permission: PERMISSION.viewPersonMembership });

  return {
    loaded,
    canViewPersonMembership
  };
}
